import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const editPartnerAction = createAsyncThunk(
    'edit-partner',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/editPartner`,{...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editPartnerSlice = createSlice({
    name: 'edit-partner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editPartnerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editPartnerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editPartnerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editPartnerReducer = editPartnerSlice.reducer